import React, { useMemo } from 'react';
import './TextToReadPopup.css';

const TextToReadPopup = ({ show, emotion = 'joyeux' }) => {
  
  // Texte joyeux de 45 secondes (185 mots)
  const joyfulText = useMemo(() => `C'est une magnifique journée ensoleillée ! Les rayons dorés du soleil caressent doucement mon visage et réchauffent mon cœur. Je me sens incroyablement heureux et plein de vie.

Les oiseaux chantent leur mélodie joyeuse dans les arbres verdoyants. Leurs trilles mélodieux résonnent comme une symphonie de bonheur. Chaque note semble danser dans l'air printanier.

Je respire profondément cet air frais et pur. Mes poumons se remplissent d'une énergie nouvelle et revigorante. Tout mon être vibre d'une joie contagieuse et lumineuse.

Autour de moi, la nature s'épanouit dans toute sa splendeur. Les fleurs multicolores embellissent le paysage de leurs parfums enivrants. Les papillons voltigent gracieusement de pétale en pétale.

Cette journée parfaite me remplit d'une gratitude immense. Mon cœur déborde de reconnaissance pour tous ces petits bonheurs simples qui illuminent ma vie quotidienne.`, []);

  // Texte triste de 45 secondes (185 mots)
  const sadText = useMemo(() => `Les nuages gris obscurcissent le ciel et mon âme se sent lourde de tristesse. Une mélancolie profonde envahit tout mon être. Les larmes coulent silencieusement sur mes joues fatiguées.

Le silence pesant de cette chambre vide résonne comme un écho de ma solitude. Mes pensées tourmentées me ramènent sans cesse vers ces souvenirs douloureux. Chaque battement de cœur semble porter le poids de la peine.

Je regarde par la fenêtre cette pluie monotone qui tambourine contre les carreaux. Le monde extérieur reflète parfaitement l'état de mon cœur brisé. Tout semble terne et sans espoir aujourd'hui.

Les photos jaunies sur ma table me rappellent cruellement des moments passés qui ne reviendront jamais. L'absence de ceux que j'aimais creuse un vide immense dans ma poitrine oppressée.

Cette tristesse profonde m'accompagne comme une ombre fidèle. Je me sens perdu dans ce labyrinthe d'émotions sombres qui semblent ne jamais vouloir se dissiper complètement.`, []);

  const textToRead = emotion === 'triste' ? sadText : joyfulText;

  if (!show) return null;

  const isJoyful = emotion === 'joyeux';
  
  return (
    <div className="text-popup" style={{
      position: 'fixed',
      top: '50%',
      [isJoyful ? 'right' : 'left']: '20px',
      transform: 'translateY(-50%)',
      backgroundColor: 'rgba(20, 20, 30, 0.95)',
      color: 'white',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      backdropFilter: 'blur(10px)',
      borderRadius: '12px',
      padding: '30px',
      width: '350px',
      maxHeight: '400px',
      textAlign: 'left',
      zIndex: 2000
    }}>
      
      <h3 style={{ 
        margin: '0 0 20px 0', 
        color: isJoyful ? '#00ff88' : '#ff6b6b', 
        fontSize: '18px',
        fontWeight: '600',
        textAlign: 'center'
      }}>
        {isJoyful ? '😊' : '😢'} Texte à lire
      </h3>
      
      <div style={{
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '8px',
        padding: '20px',
        margin: '15px 0',
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#e8f4f8',
        maxHeight: '250px',
        overflowY: 'auto'
      }}>
        <div style={{
          minHeight: '200px',
          whiteSpace: 'pre-line'
        }}>
          {textToRead}
        </div>
      </div>
      
      <p style={{
        fontSize: '12px',
        color: 'rgba(255, 255, 255, 0.7)',
        margin: '15px 0 0 0',
        fontStyle: 'italic',
        textAlign: 'center'
      }}>
        Lisez ce texte à voix haute avec expression
      </p>
      
    </div>
  );
};

export default TextToReadPopup;